module.exports = __webpack_public_path__ + "img/SketchPngb319a7160e2ab3715c4f95b2dcf0bb70db9de4df3460187dc7f651ffcbb522e9.be80030e.png";